export enum LAYOUT_MODE {
    DEFAULT = 'default',
    GRID = 'grid',
    LIST = 'list',
}
